module.exports = __webpack_public_path__ + "static/media/server_down_s4lk-2.3227eb90.svg";